var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackjack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 20v-3a1.75 1.75 0 0 0-3.5 0v3a1.75 1.75 0 0 0 3.5 0ZM33 50.25A1.749 1.749 0 0 0 31.25 52v3a1.75 1.75 0 0 0 3.5 0v-3A1.749 1.749 0 0 0 33 50.25ZM26 46.25h-2.25v-4.169a6.907 6.907 0 0 0 7.538-11.268l-8.051-8.05a1.748 1.748 0 0 0-2.474 0l-8.051 8.051A6.906 6.906 0 0 0 20.25 42.08v4.17H18a1.75 1.75 0 0 0 0 3.5h8a1.75 1.75 0 0 0 0-3.5Zm-5.238-8.85-.732.732a3.425 3.425 0 0 1-4.843-4.843L22 26.475l6.813 6.813a3.425 3.425 0 1 1-4.844 4.844l-.732-.732a1.749 1.749 0 0 0-2.475 0Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4 45.381 46.354 4.034A5.757 5.757 0 0 0 38.984.6L17.959 8.25H8A5.756 5.756 0 0 0 2.25 14v44A5.756 5.756 0 0 0 8 63.75h28a5.756 5.756 0 0 0 5.708-5.082l16.258-5.918a5.756 5.756 0 0 0 3.434-7.369ZM38.25 58A2.253 2.253 0 0 1 36 60.25H8A2.253 2.253 0 0 1 5.75 58V14A2.253 2.253 0 0 1 8 11.75h28A2.253 2.253 0 0 1 38.25 14Zm18.519-8.538L41.75 54.928V14A5.756 5.756 0 0 0 36 8.25h-7.808l11.989-4.364a2.254 2.254 0 0 1 2.884 1.345l15.049 41.347a2.254 2.254 0 0 1-1.345 2.884Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackjack);
export default __webpack_public_path__ + "static/media/blackjack.a736f19d934a44c7eb084f50b3d7e84b.svg";
export { ForwardRef as ReactComponent };